export default {
  membershipValidity: {
    serviceStatus: 'Service status',
    pendingActivation: 'Pending activation',
    renewed: 'Renewed',
    effectiveFrom: 'Expected to take effect on {date}',
    details: 'View details',
  },
};
